import React, { Component } from 'react';
import Config from './Config';
import List from './List';
import ShippingService from './ShippingService';
import User from './User';
import Integration from './Integration';
import Preferences from './Preferences';
import Tariff from './Tariff';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/Account.css';
import FX from './functions/functions';
//import OrderEdge from './OrderEdge';

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = { show: null };
  }
  componentDidMount(){
    this.props.root.current = this;
  }
  componentWillUnmount(){
    this.props.root.current = undefined;
  }
  refresh = () => {
    console.log('xxQQQxx');
    this.show(undefined);
  }
  retrieveData = (limit) => {
    if(isNaN(limit)){
      limit = 30;
      if(parseInt(this.props.root.state.current_customer.products.limit,10)){
        console.log(limit = parseInt(limit,10) + parseInt(this.props.root.state.current_customer.products.limit,10));
      }
    }
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {user_login_id: this.props.root.state.user.id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'settings/' + this.props.root.state.user.id, (res, i) => {
      var currUser = {};
      if (this.props.root.state.current_user){
        currUser = this.props.root.state.current_user;
      }
      currUser.settings = res.user_login.settings;
      console.log(JSON.parse(currUser.settings));
      this.props.root.setState({ current_user : currUser  });
      this.props.root.loadNextPage =  this.retrieveData;
    });
  }
  componentWillMount(){
    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    var found = false;
    if(x[1] && parseInt(x[1],10)){
        console.log(parseInt(x[1],10));
        var root_state = this.props.root.state;
        this.props.root.state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            root_state.detail = ping;
            return found = true;
          }
          return false;
        }
        );
     }
      if (x[1] && !found) {
        this.retrieveDetail(parseInt(x[1],10));
        //console.log('/' + x[0]);
        //FX.navigate.bind(this,state.panel, undefined ,'/' + x[0],state,true)();
        //window.location = '/' + x[0];
      }
  }
  retrieveDetail = (id) => {
    console.log('pop');
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {id: id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'product_detail' + qs , (res, i) => {
      var detail = this.props.root.setState({detail: res.product});
    });
  }
  show = (target) => {
    var panelData = this.props.root.state.panelData;
    panelData.account = {setting : target};
    this.props.root.setState({panelData : panelData});
  }
  render() {
      var shippingService;
      var setting = this.props.root.state.panelData.account.setting;
      if(setting === 'ShippingService'){
        return (
            <div className="Account">
              <ShippingService root={this.props.root} />
            </div>
        )
      }
      if(setting === 'User'){
        return (
            <div className="Account">
              <User root={this.props.root} />
            </div>
        )
      }
      if(setting === 'Tariff'){
        return (
            <div className="Account">
              <Tariff root={this.props.root} />
            </div>
        )
      }
      if(setting === 'Integrations'){
        return (
            <div className="Account">
              <Integration root={this.props.root} />
            </div>
        )
      }
      if(setting === 'Preferences'){
        return (
            <div className="Account">
              <Preferences root={this.props.root} />
            </div>
        )
      }
















      return (
        <div className="Account">
          <div onClick={this.show.bind(this,'User')}>Users</div>
          <div onClick={this.show.bind(this,'Tariff')}>Tariffs</div>
          <div onClick={this.show.bind(this,'ShippingService')}>Shipping Services</div>
          <div onClick={this.show.bind(this,'Integrations')}>Integrations</div>
          <div>Password</div>
        </div>
      );
  }
}

export default Account;



// WEBPACK FOOTER //
// ./src/Account.js